import axios from "../../api/axios";

export async function fetchSystemTypes() {
  return axios.get("/customers/systems/types");
}

export async function fetchCustomerSystem(customerId, id) {
  return axios.get(`/customer_systems/${id}`);
}

export async function fetchCustomerSystems(customerId, params = {}) {
  return axios.get("/customer_systems", { params: { ...params, ...(customerId ? { customer_id: customerId } : {}) } });
}

export async function createSystem(payload) {
  return axios
    .post('/customer_systems', { system: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function mergeCustomerSystem(customerId, targetId, sourceId) {
  return axios.post(`/customer_systems/${targetId}/merge`, {
    source_id: sourceId,
  });
}

export async function updateSystem(payload) {
  return axios
    .put(`/customer_systems/${payload.id}`, {
      system: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export const fetchSystemHistory = (id) => axios.get(`/customer_systems/${id}/history`);
